import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhCN from './lang/zh-CN'
import enUS from './lang/en-US'

Vue.use(VueI18n)

const LANGUAGE_KEY = 'mall-pc-web-language'
const SUPPORTED_LANGUAGES = ['zh-CN', 'en-US']
const ADMIN_ROUTE_PREFIXES = ['/admin', '/pms', '/oms', '/sms', '/ums', '/cms']

export function isAdminRoute(path) {
  return ADMIN_ROUTE_PREFIXES.some(prefix => path.indexOf(prefix) === 0)
}

export function getStoredLanguage() {
  return localStorage.getItem(LANGUAGE_KEY)
}

export function getDefaultLanguage() {
  const stored = getStoredLanguage()
  if (stored && SUPPORTED_LANGUAGES.indexOf(stored) !== -1) {
    return stored
  }
  return 'en-US'
}

const messages = {
  'zh-CN': Object.assign({}, zhCN, { el: zhLocale }),
  'en-US': Object.assign({}, enUS, { el: enLocale })
}

const i18n = new VueI18n({
  locale: getDefaultLanguage(),
  fallbackLocale: 'en-US',
  messages
})

export function setLanguage(lang) {
  const locale = SUPPORTED_LANGUAGES.indexOf(lang) !== -1 ? lang : 'en-US'
  i18n.locale = locale
  localStorage.setItem(LANGUAGE_KEY, locale)
  document.documentElement.setAttribute('lang', locale)
  return locale
}

function setRuntimeLocale(lang) {
  const locale = SUPPORTED_LANGUAGES.indexOf(lang) !== -1 ? lang : 'en-US'
  i18n.locale = locale
  document.documentElement.setAttribute('lang', locale)
  return locale
}

export function syncLocaleByRoute(path) {
  if (isAdminRoute(path)) {
    return setRuntimeLocale('zh-CN')
  }
  return setRuntimeLocale(getStoredLanguage() || getDefaultLanguage())
}

setLanguage(i18n.locale)

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js